/**
 * MemoryCacheDriver.ts
 * @author Diao Zheng
 * @file An in-memory cache driver with custom cache timeout heuristics
 */
import _ from "lodash";
import { MemoryCache } from "nasi";
import { map } from "rxjs/operators";
import { LinearTimeoutHeuristic } from "./LinearTimeoutHeuristic";
export class MemoryCacheDriver {
    constructor(heuristic) {
        this.updateHeuristic = (value) => {
            this.heuristic.update(value);
        };
        this.heuristic = (heuristic !== null && heuristic !== void 0 ? heuristic : new LinearTimeoutHeuristic());
    }
    get get() {
        return map((key) => MemoryCache.get(key, _.isEqual));
    }
    get set() {
        return map(([key, value]) => {
            MemoryCache.set(key, value, Date.now() + this.heuristic.currentTimeout);
            return value;
        });
    }
}
